import React, { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@ui-seeker/app"
import { object, string } from "yup"
import { autoEuropeSeasonSetsDrawerData, autoEuropeSeasonSetsDrawerErrors } from "Pages/AutoEuropeTool/SeasonSets/@signals"

export default function AutoEuropeSeasonSetsNameField() {
	const name = useSignal(autoEuropeSeasonSetsDrawerData.peek().name || null)

	const { errors, isValid } = useValidatorSeeker({ name: name.value }, object({
		name: string()
			.required("Name is required")
			.min(3, "Name must be at least 3 characters long")
			.max(100, "Name can be at most 100 characters long")
	}))

	useEffect(() => {
		autoEuropeSeasonSetsDrawerErrors.value = { ...autoEuropeSeasonSetsDrawerErrors.value, name: isValid }
	}, [JSON.stringify(errors)])

	const handleChange = e => batch(() => {
		name.value = e.target.value
		autoEuropeSeasonSetsDrawerData.value = { ...autoEuropeSeasonSetsDrawerData.value, name: e.target.value }
	})

	return <TextFieldSeeker
		label="Name"
		value={name.value || ""}
		onChange={handleChange}
		error={errors?.name}
	/>
}
